import React, { useEffect, useRef } from 'react';
import { colors, fontFamily, fontSizes, fontWeights, radii, shadows } from '../../theme/tokens';
import { Button, Icon, Tag } from '../ui';

const ComingSoonModal = ({ label, onClose }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    if (closeRef.current) closeRef.current.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000, overflowY: 'auto', background: colors.overlay,
        display: 'flex', padding: 16, boxSizing: 'border-box', fontFamily,
      }}
    >
      <section
        role="dialog"
        aria-modal="true"
        aria-label={label + ' coming soon'}
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative', margin: 'auto', width: '100%', maxWidth: 440, boxSizing: 'border-box',
          maxHeight: 'calc(100dvh - 32px)', overflowY: 'auto',
          padding: '40px 28px 28px', borderRadius: radii.modal, background: colors.white, boxShadow: shadows.modal,
          display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 14,
        }}
      >
        <button
          ref={closeRef}
          type="button"
          aria-label="Close"
          onClick={onClose}
          style={{
            position: 'absolute', top: 16, right: 16, width: 44, height: 44, border: 0, borderRadius: 22,
            background: 'transparent', color: colors.slate, display: 'flex', alignItems: 'center',
            justifyContent: 'center', cursor: 'pointer',
          }}
        >
          <Icon name="close" size={22} strokeWidth={2.2} />
        </button>
        <span
          style={{
            width: 76, height: 76, borderRadius: 38, background: colors.mistStrong, color: colors.navy,
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}
        >
          <Icon name="book" size={36} strokeWidth={1.7} />
        </span>
        <Tag variant="teal" style={{ overflowWrap: 'anywhere' }}>{label}</Tag>
        <h2 style={{ margin: 0, fontSize: fontSizes.h2, lineHeight: 1.15, fontWeight: fontWeights.bold, color: colors.ink }}>
          Feature coming soon
        </h2>
        <p style={{ margin: '0 0 8px', fontSize: fontSizes.body, lineHeight: 1.6, color: colors.slate }}>
          We're getting this section ready. In the meantime, you can order your school's complete book set from School Zone.
        </p>
        <Button to="/search" fullWidth size="lg" onClick={onClose}>Go to School Zone</Button>
        <Button variant="secondary" fullWidth size="lg" onClick={onClose}>Close</Button>
      </section>
    </div>
  );
};

export default ComingSoonModal;
